import { useDispatch, useSelector } from "react-redux";
import { hideToaster } from "../../redux/slices/toastSlice";
import { useEffect } from "react";
import { Box, IconButton } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { palette } from "../../themes/theme";

export default function Toaster() {
  const toastState = useSelector((state) => state.toast);
  const backgroundColor =
    toastState.dialogBgColor === "bg-danger"
      ? palette.background.danger
      : palette.background.success;
  const dispatch = useDispatch();
  const onDismissToast = () => {
    dispatch(hideToaster());
  };

  useEffect(() => {
    if (toastState.timer) {
      setTimeout(() => {
        onDismissToast();
      }, +toastState.timer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toastState]);

  return (
    <>
      {toastState.showDialog && (
        <>
          <Box
            sx={{
              position: "absolute",
              width: "320px",
              minHeight: "70px",
              textWrap: "wrap",
              bottom: 20,
              left: "42%",
              background: backgroundColor,
              color: palette.text.white,
              border: `4px solid ${palette.text.white80}`,
              borderRadius: "9px",
              display: "flex",
              alignItems: "center",
              gap: 2,
              py: 1,
              px: 1,
            }}
          >
            <Box>
              {toastState.dialogBgColor === "bg-danger" ? (
                <WarningAmberIcon
                  sx={{ fontSize: 30, color: palette.text.white }}
                />
              ) : (
                <CheckCircleIcon
                  sx={{ fontSize: 30, color: palette.text.white }}
                />
              )}
            </Box>
            <Box sx={{ overflow: "hidden", overflowWrap: "break-word" }}>
              {toastState.dialogMsg}
            </Box>
            <IconButton
              sx={{
                position: "absolute",
                top: -10,
                right: -10,
                color: backgroundColor,
                background: palette.text.white,
                padding: "1px",
              }}
              onClick={onDismissToast}
            >
              <CancelIcon />
            </IconButton>
          </Box>
        </>
      )}
    </>
  );
}
